import { useCallback } from 'react';
import { useModal } from '@flyer/components';
import { SignInModalLazy } from '@/components/popups';
import useSignUpFlowModal from './useSignUpFlowModal';
import useForgotPasswordModal from './useForgotPasswordModal';

/**
 * Hook to manage authentication modals with proper transitions
 * Provides a single function to open SignIn modal with callbacks for SignUp and ForgotPassword
 */
export default function useAuthModals() {
  const { openSignUp } = useSignUpFlowModal();
  const { openForgotPassword } = useForgotPasswordModal();
  const { toggleModal: toggleSignIn, hideModal: hideSignIn } = useModal(SignInModalLazy);

  const openSignInModal = useCallback(() => {
    const handleOpenSignIn = (): void => {
      toggleSignIn({
        onSignUpClick: () => {
          hideSignIn();
          openSignUp(() => handleOpenSignIn());
        },
        onForgotPasswordClick: () => {
          hideSignIn();
          openForgotPassword({ onSignInClick: () => handleOpenSignIn() });
        },
      });
    };

    handleOpenSignIn();
  }, [toggleSignIn, hideSignIn, openSignUp, openForgotPassword]);

  return {
    openSignInModal,
  };
}
